import { ActivityLogsPayload, ActivityLogs, ActivityLogsAction } from "../interfaces/global-interfaces";

export default function activityLoggerReducer(state: ActivityLogsPayload[] = [], action: ActivityLogs) {
    switch (action.type) {
        case ActivityLogsAction.Update:
            return action.payload && action.payload.length > 0 ?[...action.payload]: [...state];
        default:
            return state;
    }
}